document.addEventListener('click', function (e) {
  const input = e.target.closest('input[data-variant-id]');
  
  if (input) {
    const variantId = input.dataset.variantId;

    const variantField = document.querySelector(
      '[bss-b2b-quickview-product-form] [bss-b2b-variant-id]'
    );

    if (variantField) {
      if (variantField.tagName === 'INPUT') {
        variantField.value = variantId;
      } 
      else {
        variantField.setAttribute('bss-b2b-variant-id', variantId);
        setTimeout(() => {
            const productForm = document.querySelector("[bss-b2b-quickview-product-form]");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                    productForm
                });
                document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
        }, 2000);
      }
    }
  }
});